import { UserCheck } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="fe-seccion fe-rsvp" aria-label={seccion.titulo}>
      <div className="fe-seccion-interior">
        <EncabezadoSeccion p="fe" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="fe-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="fe-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="fe-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="fe-boton fe-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="fe-boton-rsvp"
          >
            <UserCheck strokeWidth={1.8} />
            {rsvp.textoBoton || "Reservar mi lugar"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
